import React from 'react';
import { IUser } from '../../../interfaces/IUser';


export const hello = () => {
    console.log("Hello");
}


//Essa função pode ser replicada ou usada em outros lugares
export const handleFieldChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  field: string,
  user: IUser,
  setUser: React.Dispatch<React.SetStateAction<IUser>>
) => {
  setUser({
    ...user,
    [field]: e.target.value,
  });
};


export const handleWithLogin = async (
    type: number,
    user: IUser,
    setButtonText: React.Dispatch<React.SetStateAction<string>>,
    signUp: (user: IUser) => Promise<void>,
    signIn: (user: IUser) => Promise<void>,
    authWithCode: (code: string) => Promise<void>,
    loading: boolean
  ) => {
    try {
      setButtonText("Aguarde...");
  
      if (type === 0) {
        sessionStorage.setItem("code", user.code || "");
        await authWithCode(user.code || "");
      }
      if (type === 1) await signIn(user);
      if (type === 2) await signUp(user);
    } finally {
      setTimeout(() => {
        setButtonText(type === 0 ? "Entrar" : type === 1 ? "Login" : "Cadastrar");
      }, 800);
    }
  };


